import React, { ReactElement, useEffect, useState } from 'react';
import { ResponseMission } from '../../../../services/api/models/response/responseMission';
import {
  useGetMissionsQuery,
  useReceiveMissionPrizeMutation,
} from '../../../../services/api/apiProvider';
import { BarLoader } from 'react-spinners';
import { MissionTabItem } from './MissionTabItem';
import { Alert, Card } from 'react-bootstrap';
import './LiveMissionTab.scss';
import { StyleButtonGetProps } from './LiveMissionModal';
import { useDispatch } from 'react-redux';
import {
  toggleConfirmGiftMissionModal,
  updateListMissionConfirm,
} from './LiveMissionSlice';
import LiveMissionConfirmGiftModal from './LiveMissionConfirmGiftModal';

const LiveMissionTab = (): ReactElement => {
  const dispatch = useDispatch();
  const { data: missionData, isLoading, error } = useGetMissionsQuery();
  const [workingMissions, setWorkingMissions] = useState<ResponseMission[]>([]);
  const [doneMissions, setDoneMissions] = useState<ResponseMission[]>([]);
  const [receivePrize] = useReceiveMissionPrizeMutation();
  const [styleButtonGetAll, setStyleButtonGetAll] = useState<
    StyleButtonGetProps | undefined
  >();
  // analyze mission data
  useEffect(() => {
    const workingMissionData: ResponseMission[] = [];
    const doneMissionData: ResponseMission[] = [];

    missionData?.forEach((m) => {
      if (m.receivedDateTime) {
        doneMissionData.push(m);
      } else {
        workingMissionData.push(m);
      }
    });
    const index = workingMissionData.findIndex(
      (mission) => mission.measuredValue === mission.targetValue,
    );
    if (index < 0) {
      setStyleButtonGetAll({ backgroundColor: '#c0c0c0', cursor: 'default' });
    } else {
      setStyleButtonGetAll({
        backgroundColor: '#ff64de',
        cursor: 'pointer',
      });
    }

    setWorkingMissions(workingMissionData);
    setDoneMissions(doneMissionData);
  }, [missionData]);

  /**
   * Handle receive mission prize
   * @param mission
   */
  const handleReceivePrize = async (mission: ResponseMission) => {
    // call receive prize api
    const listMission = [];
    const response = await receivePrize({
      id: mission.id,
      verify: false,
    }).unwrap();
    if (!response) {
      return;
    }
    if (response) {
      listMission.push(mission);
      dispatch(updateListMissionConfirm(listMission));
      dispatch(toggleConfirmGiftMissionModal(true));
    }
  };
  const handleTakeAllGift = async () => {
    const listMission = [];
    for (let i = 0; i < workingMissions.length; i++) {
      if (workingMissions[i].measuredValue === workingMissions[i].targetValue) {
        listMission.push(workingMissions[i]);
      }
    }
    if (listMission.length > 0) {
      for (let i = 0; i < listMission.length; i++) {
        const response = await receivePrize({
          id: listMission[i].id,
          verify: false,
        }).unwrap();
        if (!response) {
          return;
        }
      }
      dispatch(updateListMissionConfirm(listMission));
      dispatch(toggleConfirmGiftMissionModal(true));
    }
  };

  return (
    <div className="live-missions">
      <Card className="live-missions__content">
        {isLoading && (
          <div className="gift-tab__loader">
            <BarLoader color={'#0275d8'} width="100%"></BarLoader>
          </div>
        )}
        <div
          onClick={handleTakeAllGift}
          className="mission-btn__take-all-gift"
          style={styleButtonGetAll}
        >
          まとめて受け取る
        </div>
        {missionData && missionData.length > 0 && (
          <>
            {/* Working mission list */}
            <Card.Body className="live-missions-list">
              {workingMissions.map((mission) => (
                <MissionTabItem
                  key={mission.id}
                  mission={mission}
                  onReceiveBtnClick={() => {
                    handleReceivePrize(mission);
                  }}
                />
              ))}
              {/* Done mission list */}
              <p className="text-divider">受け取り済</p>
              {doneMissions.map((mission) => (
                <MissionTabItem key={mission.id} mission={mission} />
              ))}
            </Card.Body>
          </>
        )}

        {error && (
          <Alert variant="danger" className="mission-error-message">
            {(error as any).data.errorMessage}
          </Alert>
        )}
      </Card>
    </div>
  );
};

export default LiveMissionTab;
